import React from 'react'
import { useEffect } from 'react'
import useOutsideClick from '../../../hooks/useOutSideClick';
import { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CheckBoxContainer, CommonDeptLocContainer } from './style';
import { Border } from '../../RecogntionAdmin/styles';
import { RecognitionTickIcon } from '../../../utils/icons';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import {CompanyLocationAPI,CompanyDepartmentAPI} from '../../../redux/constants/apiConstants';

const DeptLoc = ({/*departmentDetails, locationDetails,*/companyId, isDropdownOpen, setIsDropdownOpen,fetchCelebrationsDetails,activeSubTab}) => {
  const [selectedDepartments, setSelectedDepartments]= useState([]);
  const [selectedLocations, setSelectedLocations]= useState([]);
  const [locationData, setLocationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);


  const ref = useOutsideClick(() => {
    setIsDropdownOpen(false);
  });

  // useEffect(() => {
  // },[]);

  useEffect(() => {
    fetchLocation();
    fetchDepartment();
  },[])

  useEffect(()=>{
    // fetchLocation();
    // fetchDepartment();
    setSelectedDepartments([]);
    setSelectedLocations([]);
  },[activeSubTab])
  
  const fetchLocation = async() => {
    let apiUrl = `${CompanyLocationAPI}?company_id=${companyId}`;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res?.data?.message){
        toast.error(res.data.message)
      }else{
        setLocationData(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }};

  const fetchDepartment = async() => {
    let apiUrl = `${CompanyDepartmentAPI}?company_id=${companyId}`;
    try {
      const res = await fetchApi(apiUrl,"GET");
      if(res?.data?.message){
        toast.error(res.data.message)
      }else{
        setDepartmentData(res?.data)
      }
    } catch (error) {
      toast.error(error);
    }};

  useEffect(() => {
    fetchCelebrationsDetails(selectedDepartments, selectedLocations);
  }, [selectedDepartments, selectedLocations]);

  const SelectDepartment = (id)=>{
    const allDepartments = [...selectedDepartments];
    if (allDepartments.includes(id)) {
      let index = allDepartments.findIndex((item) => item === id);
      if (index > -1) {
        allDepartments.splice(index, 1);
      }
    } else {
      allDepartments.push(id);
    }

    setSelectedDepartments(allDepartments)
  }
  const selectAllDepartments = () => {
    if (selectedDepartments.length == departmentData?.length) {
      setSelectedDepartments([]);
    } else {
      let arr = [];
      for (let i = 0; i < departmentData?.length; i++) {
        arr.push(departmentData[i].id);
      }
      setSelectedDepartments(arr);
    }
  };
  

  const SelectLocation = (id)=>{
    const allLocations = [...selectedLocations];
    if (allLocations.includes(id)) {
      let index = allLocations.findIndex((item) => item === id);
      if (index > -1) {
        allLocations.splice(index, 1);
      }
    } else {
      allLocations.push(id);
    }

    setSelectedLocations(allLocations)
  }

  const selectAllLocations = () => {
    if (selectedLocations.length == locationData?.length) {
      setSelectedLocations([]);
    } else {
      let arr = [];
      for (let i = 0; i < locationData?.length; i++) {
        arr.push(locationData[i].id);
      }
      setSelectedLocations(arr);
    }
  };
  return (
    <>{isDropdownOpen ? 
      <CommonDeptLocContainer ref={ref}>
        <div className='dept-loc-conteiner'>
          {departmentData.length ? <div className="all-department">
            <div className="department-title">
              <CheckBoxContainer selected={selectedDepartments.length === departmentData.length ? true : false}  onClick={()=>selectAllDepartments()}>
                <div className="archive-action">{selectedDepartments.length === departmentData.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer>
              <span className='dept-name'>All Departments</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {departmentData.map((department, index)=>(
                <div key={index + department.id} className="department-row" onClick={()=>SelectDepartment(department.id)}>
                  <CheckBoxContainer selected={selectedDepartments.includes(department.id) ? true : false}>
                    <div className="archive-action" >{selectedDepartments.includes(department.id) ?  RecognitionTickIcon() : null}</div>
                  </CheckBoxContainer>
                  <span className='dept-name'>{department.department}</span>
                </div>
              ))}
            </div>
          </div>:null}
          
          {locationData.length ? <div className="all-location">
            <div className="department-title">
              <CheckBoxContainer selected={selectedLocations.length === locationData.length ? true : false} onClick={()=>selectAllLocations()}>
                <div className="archive-action" >{selectedLocations.length === locationData.length ?  RecognitionTickIcon() : null}</div>
              </CheckBoxContainer>
              <span className='dept-name'>All Locations</span>
            </div>
            <Border style={{border:"1px solid #EFEFEF",margin:"8px 0px"}}/>
            <div className="department-list">
              {locationData.map((location, index)=>(
                <div key={index + location.id} className="department-row" onClick={()=>SelectLocation(location.id)}>
                  <CheckBoxContainer selected={selectedLocations.includes(location.id) ? true : false}>
                    <div className="archive-action">{selectedLocations.includes(location.id) ?  RecognitionTickIcon() : null}</div>
                  </CheckBoxContainer>
                  <span className='dept-name'>{location.location}</span>
                </div>
              ))}
            </div>
          </div>:null}
        </div>
      </CommonDeptLocContainer>
      : null}</>
  )
}

DeptLoc.propTypes = {
  departmentDetails: PropTypes.array,
  locationDetails: PropTypes.array,
  isDropdownOpen: PropTypes.bool, 
  setIsDropdownOpen: PropTypes.func,
  fetchCelebrationsDetails: PropTypes.func,
  companyId: PropTypes.number,
  activeSubTab: PropTypes.string,
}

const mapStateToProps = (state) => ({
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  
})

export default connect(mapStateToProps, null)((DeptLoc));